module.exports = __webpack_public_path__ + "static/media/downtimedollars-logo-horizontal.5cf933ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/downtimedollars-logo-horizontal.png
// module id = 349
// module chunks = 0